import Header from './Header'
import MainMenu from './MainMenu'
import {React} from 'react'

const Index = () => {
  return (
    <>
    <Header />
    <MainMenu/>
    </>
  )
}

export default Index



